/* import __COLOCATED_TEMPLATE__ from './select-team-fallback.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type ImportConfigurationService from 'embercom/services/data/import-configuration-service';
import type Team from 'embercom/models/team';

export interface Args {}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

export default class SelectTeamFallback extends Component<Signature> {
  @service declare appService: AppService;
  @service('data/import-configuration-service')
  declare importConfigurationService: ImportConfigurationService;
  @service declare intl: IntlService;

  get items() {
    let items = this.appService.app.assignableTeams;

    let options = items.map((item: Team) => {
      return {
        text: item.name,
        value: item.id,
        component:
          'new-settings/data/imports-exports/import-zendesk/config-import/sections/lib/select-team-dropdown-option',
        componentAttrs: { model: item },
      };
    });
    return options;
  }

  get itemId() {
    let itemId: string | null = this.importConfigurationService.fallbackTeamId;

    if (this.items.some((item: { value: string }) => item.value === itemId)) {
      return itemId!;
    }

    return undefined;
  }

  @action onSelectItem(value: string) {
    this.importConfigurationService.setFallbackTeamId(value);
  }

  @action onDeselectItem() {
    this.importConfigurationService.setFallbackTeamId(null);
  }

  translation = (path: string) => this.intl.t(this.translationKey(path));
  private translationKey = (path: string) =>
    `new-settings.data.imports-exports.import-zendesk.config-import-page.select-team-fallback.${path}`;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Data::ImportsExports::ImportZendesk::ConfigImport::Sections::Lib::SelectTeamFallback': typeof SelectTeamFallback;
    'new-settings/data/imports-exports/import-zendesk/config-import/sections/lib/select-team-fallback': typeof SelectTeamFallback;
  }
}
